import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { CONFIG } from '../utils/config';

const IndustrySelect = props => {
  const [terms, setTerms] = useState();
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState(props.type);

  useEffect(() => {
    const getType = async type => {
      const response = await fetch(`${CONFIG.API_URL}${CONFIG.INDUSTRY}?sort=weight`);

      const termData = await response.json();
      const termOptions = termData?.data.map(item => {
        return {
          // key: item.attributes.drupal_internal__tid,
          key: item.id,
          name: item.attributes.name,
        };
      });
      await setTerms(termOptions);
      await setLoading(false);
    };

    getType();
  }, [loading]);

  return (
    <Form.Group>
      <Form.Label>{props.label}</Form.Label>
      {!loading && (
        <Form.Control
          as="select"
          size=""
          custom
          onChange={props.onChange}
          value={props.selected}
        >
          {/*<option defaultValue>{props.selected}</option>*/}
          <option value="All categories">All categories</option>
          {terms.map(item => (
            <option value={item.name} key={item.key}>
              {item.name}
            </option>
          ))}
        </Form.Control>
      )}
    </Form.Group>
  );
};

export default IndustrySelect;
